<h1  mat-dialog-title class="p-2 text-center">Nouveau substrat</h1>
<div class="p-3">
    <div class="col">
        <div class="row">
            <mat-form-field class="col">
                <mat-label>Substrat</mat-label>
                <mat-select placeholder="Substrat" [(ngModel)]="model.Type" required>
                    <mat-option *ngFor="let p of TypeSubstratList; let i = index" [value]="i + 1">
                        <span>{{p}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="col">
                <mat-label>Zone</mat-label>
                <mat-select placeholder="Zone" [(ngModel)]="model.Zone" required>
                    <mat-option *ngFor="let p of ZoneList; let i = index" [value]="i + 1">
                        <span>{{p}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="col">
                <mat-label>Importance</mat-label>
                <mat-select placeholder="Importance" [(ngModel)]="model.Importance" [required]="model.Zone ===  EZone.Berge || model.Zone === EZone.IntermediaireAccessible">
                    <mat-option *ngFor="let p of ImportanceList; let i = index" [value]="i + 1">
                        <span>{{p}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row">
            <button appPreventDoubleClick class="col mx-3 my-2" color="accent" mat-raised-button (throttledClick)="onCancel()">
                Annuler
            </button>
        </div>
        <div class="row">
            <button appPreventDoubleClick class="col mx-3 my-1" color="primary" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanAdd">
                Sauvegarder
            </button>
        </div>
    </div>
</div>
